import React, { Component } from 'react'
import { Card, Button, Row, Col } from 'antd'
import { DownCircleOutlined, UpCircleOutlined } from '@ant-design/icons'
import { ExtendedTableColumnType, SortByOptions, TransferTable } from './TransferTable'

export type TableColumn = {
  source: ExtendedTableColumnType<any>[],
  target: ExtendedTableColumnType<any>[]
}

export type Selection = {
  source: any[],
  target: any[]
}

export type SortBy = {
  source?: SortByOptions,
  target?: SortByOptions
}

export interface SelectedKeys {
  key: string,
  data: any[]
}

/**
 * Component props
 */
export type VerticalTableTransferProps = {
  rowKey: string,
  columns: TableColumn,
  dataSource: any[],
  intialSelectedKeys?: any[] | SelectedKeys,
  sortBy?: SortBy,

  onChange?: (selectedKeys: any[]) => void
}

type VerticalTableTransferState = {
  selection: Selection,
  selectedKeys: Set<string | number>
}

export class VerticalTableTransfer extends Component<VerticalTableTransferProps> {

  state: VerticalTableTransferState = {
    selection: {
      source: [],
      target: []
    },
    selectedKeys: new Set<any>(this.getInitialKeys())
  }

  private sourceTableRef: any = null
  private targetTableRef: any = null

  private getInitialKeys() {
    if (!this.props.intialSelectedKeys) return []

    if (this.props.intialSelectedKeys instanceof Array) {
      return this.props.intialSelectedKeys
    }

    const key = this.props.intialSelectedKeys.key
    return this.props.intialSelectedKeys.data.map((v: any) => v[key])
  }

  private filterDataSource = (has?: boolean) => {
    const { dataSource, rowKey } = this.props
    const { selectedKeys } = this.state

    if (has) {
      return dataSource.filter(ds => ds[rowKey] && selectedKeys.has(ds[rowKey]))
    } else {
      return dataSource.filter(ds => ds[rowKey] && !selectedKeys.has(ds[rowKey]))
    }
  }

  private handleTableChange = (selected: any[], type: 'source' | 'target') => {
    const { selection } = this.state
    
    // Update selection state
    selection[type] = selected
    this.setState({
      selection
    })
  }

  private moveSelection = (type: 'add' | 'remove') => {
    const { onChange } = this.props
    const newState = Object.assign({}, this.state)

    if (type === 'add') {
      newState.selection.source.forEach(v => newState.selectedKeys.add(v))
      newState.selection.source = []
    }
    if (type === 'remove') {
      newState.selection.target.forEach(v => newState.selectedKeys.delete(v))
      newState.selection.target = []
    }

    this.setState(newState, () => {
      if (type === 'add' && this.sourceTableRef) {
        this.sourceTableRef.clearSelection()
      }
      if (type === 'remove' && this.targetTableRef) {
        this.targetTableRef.clearSelection()
      }

      if (onChange) {
        const selectedKeys: any[] = []
        newState.selectedKeys.forEach(v => selectedKeys.push(v))
        onChange(selectedKeys)
      }
    })
  }

  render() {
    const { rowKey, columns, sortBy } = this.props
    const { selection } = this.state

    return (
      <div>
        <Card title="source" size="small">
          <TransferTable
            ref={(refs) => this.sourceTableRef = refs}
            rowKey={rowKey}
            columns={columns.source}
            removeSelectAll={true}
            sortBy={sortBy?.source}
            dataSource={this.filterDataSource()}
            onChange={(selected: any[]) => this.handleTableChange(selected, 'source')}
          />
        </Card>

        <Row justify="center" gutter={24} style={{marginTop: 10, marginBottom: 10}}>
          <Col xs={8}>
            <Button
              block
              disabled={selection.source.length === 0}
              onClick={() => this.moveSelection('add')}
            >
              <DownCircleOutlined />
              ADD
            </Button>
          </Col>

          <Col xs={8}>
            <Button
              block
              disabled={selection.target.length === 0}
              onClick={() => this.moveSelection('remove')}
            >
              <UpCircleOutlined />
              REMOVE
            </Button>
          </Col>
        </Row>

        <Card title="target" size="small">
          <TransferTable
            ref={(refs) => this.targetTableRef = refs}
            rowKey={rowKey}
            columns={columns.target}
           // sortBy={sortBy?.target}
            pagination={false}
            dataSource={this.filterDataSource(true)}
            onChange={(selected: any[]) => this.handleTableChange(selected, 'target')}
          />
        </Card>
      </div>
    )
  }
}
